/**
 * Panel — surface card with optional title and subtitle.
 */
export default function Panel({ title, sub, children, span = 1, noPad, sx }) {
  return (
    <div
      className="bg-surface border border-line rounded-none overflow-hidden"
      style={{ gridColumn: `span ${span}`, ...sx }}
    >
      {title && (
        <div className="px-4 pt-3 pb-2 border-b border-line flex items-baseline gap-2">
          <span className="text-xs font-semibold text-fg2 uppercase tracking-wider">
            {title}
          </span>
          {sub && <span className="text-xs text-fg3">{sub}</span>}
        </div>
      )}
      <div className={noPad ? "" : "px-4 py-3"}>{children}</div>
    </div>
  );
}
